import { useRef } from "react";
import { TrashIcon, PencilIcon, ArrowLeftIcon } from "@heroicons/react/outline";
import CartCount from "components/CartCount";
import { getProductTotalPrice, getSelectedVariants } from "helpers/cartHelpers";
import { CartItem } from "Types";
import { useMenuContext } from "context/MenuContext";
import { getFormatedPrice } from "helpers";

interface Props {
  item: CartItem;
  onRemove: () => void;
  onChangeCartQuantity: () => void;
}

const OrderCard: React.FC<Props> = ({
  item,
  onRemove,
  onChangeCartQuantity,
}) => {
  const discardRef = useRef();
  const orderCardRef = useRef();
  const { currency_symbol } = useMenuContext();
  const handleOrderCard = () =>
    //@ts-ignore
    orderCardRef.current.scrollIntoView({ behaviour: "smooth" });

  return (
    <li className="flex overflow-x-scroll scrollbar-hide snap-x snap-mandatory w-full scroll-smooth">
      {/* @ts-ignore */}
      <div className="min-w-full snap-center snap-always" ref={orderCardRef}>
        <div className="p-4">
          <div className="flex justify-between">
            <div className="uppercase font-medium text-lg text-left">
              {item.product.title}
            </div>

            <div className="text-right text-lg font-medium">
              {getFormatedPrice(
                getProductTotalPrice({
                  product: item.product,
                  variantSelection: item.variantSelection,
                  count: item.count,
                }),
                currency_symbol
              )}
            </div>
          </div>

          {getSelectedVariants(item.product, item.variantSelection)?.map(
            (variantOption) => (
              <div key={variantOption.id} className="text-gray-900 font-light text-lg">
                {variantOption.title}
              </div>
            )
          )}

          {item.extrasSelection?.map((selection) => {
            const extraGroup = item.product.extras.find(
              (e) => e.id === selection.extraKey
            );
            if (!extraGroup) return null;
            return (
              <div key={selection.extraKey}>
                {selection.items.map((itemKey) => (
                  <div key={itemKey} className="text-gray-900 font-light text-base">
                    {
                      //@ts-ignore
                      extraGroup.items.find((i) => i._key === itemKey).item
                        .title
                    }
                  </div>
                ))}
              </div>
            );
          })}

          <div className="mt-4 grid grid-cols-editItemOrder gap-4 items-center justify-items-start">
            <div className="text-base font-light text-gray-900">
              {getFormatedPrice(
                getProductTotalPrice({
                  product: item.product,
                  variantSelection: item.variantSelection,
                  count: 1,
                }),
                currency_symbol
              )}
            </div>
            <CartCount
              changeCount={onChangeCartQuantity}
              count={item.count}
              size="small"
            />

            {/* TODO: ADD EDIT PRODUCT FUNTIONALITY.
            <Link
              //@ts-ignore
              href={`/product/${item.product.slug.current}`}
            >
              <a>
                <PencilIcon className="h-5 w-5" />
              </a>
            </Link> */}

            <TrashIcon
              onClick={() =>
                //@ts-ignore
                discardRef.current.scrollIntoView({ behaviour: "smooth" })
              }
              className="h-5 w-5 flex items-end stroke-1 stroke-gray-900"
            />
          </div>
        </div>
      </div>
      <div
        //@ts-ignore
        ref={discardRef}
        className=" bg-red-500 min-w-full gap-4 snap-center snap-always flex justify-center items-center"
      >
        <ArrowLeftIcon
          onClick={handleOrderCard}
          className="text-white h-6 lg:w-6"
        />
        <TrashIcon onClick={onRemove} className="text-white h-6 lg:w-6" />
      </div>
    </li>
  );
};

export default OrderCard;
